module.exports = __webpack_public_path__ + "img/2_1.e2742553.png";